import namespace from './namespace';
import {effect} from 'utils/redux';
import {setPageTitleMessage} from 'io/app';
import {getQuery} from 'io/history';
import * as globalActions from 'modules/common/actions';
import services from 'services';
import {loggedIn} from 'modules/common/selectors';

const creator = effect(namespace);

// `callbackPath` is the path to the azure callback. In this app it is always `window.location.pathname`, so we are matching these exactly in our router. See App.js for reference.
export let initialize = callbackPath => async (getState, dispatch) => {
	setPageTitleMessage('Uudelleen ohjataan')(getState, dispatch);

	if (loggedIn(getState())) {
		window.location.assign('/');
		return;
	}

	const redirectUrl = localStorage.getItem('redirectUrl')
		? localStorage.getItem('redirectUrl')
		: '/';

	const token = getQuery().code;

	const api = await services.waitFor('api');

	try {
		const {token: apiToken} = await api.httpJson('get', `${callbackPath}?code=${token}`);
		dispatch(globalActions.afterLogin(apiToken));
	} catch (e) {
		const resMsg = await e.response.json().then(res => res.info);
		window.location.assign(`${redirectUrl}?error=${resMsg}`);
		throw e;
	}
};
initialize = creator('initialize', initialize);
